module.exports = __webpack_public_path__ + "static/img/pro2.3cfd0d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pro2.png
// module id = 76Oi
// module chunks = 1